import request from '@/utils/request'
const baseUrl = '/account'

/**
 * 获取一个临时的token用于客户端获取明文解密key
 */
export function sendCode(data) {
  return request({
    url: `${baseUrl}/rest/sendCode`,
    method: 'POST',
    data
  })
}